import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { m } from "@/paraglide/messages";
import { getFont, SIGNATURE_FONTS, signatureFilename } from "../lib/signature";
import { downloadCanvas } from "./download";

/** Type a name, pick a handwriting font, preview it, and export a PNG. */
export function TypeSignature() {
  const [name, setName] = useState("");
  const [fontId, setFontId] = useState(SIGNATURE_FONTS[0].id);
  const font = getFont(fontId);
  const trimmed = name.trim();

  const download = () => {
    const text = trimmed || "Signature";
    const fontPx = 96;
    const pad = 24;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.font = `${fontPx}px ${font.family}`;
    const textWidth = ctx.measureText(text).width;
    // Resizing the canvas resets the context, so set font again afterwards.
    canvas.width = Math.ceil(textWidth + pad * 2);
    canvas.height = Math.ceil(fontPx * 1.6);
    ctx.font = `${fontPx}px ${font.family}`;
    ctx.fillStyle = "#0a0a0a";
    ctx.textBaseline = "middle";
    ctx.fillText(text, pad, canvas.height / 2);
    downloadCanvas(canvas, signatureFilename(name));
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="sig-name">{m.sig_name_label()}</Label>
        <Input
          id="sig-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={m.sig_name_placeholder()}
          maxLength={40}
          autoComplete="off"
        />
      </div>

      <fieldset
        className="m-0 flex flex-wrap gap-2 border-0 p-0"
        aria-label="Font"
      >
        {SIGNATURE_FONTS.map((f) => (
          <button
            key={f.id}
            type="button"
            aria-pressed={fontId === f.id}
            onClick={() => setFontId(f.id)}
            className={`rounded-md border px-3 py-1.5 text-base transition-colors ${
              fontId === f.id
                ? "border-primary bg-primary/10"
                : "border-border hover:border-primary/50"
            }`}
            style={{ fontFamily: f.family }}
          >
            {f.name}
          </button>
        ))}
      </fieldset>

      <div className="flex min-h-[140px] items-center justify-center rounded-xl border border-border bg-white p-6">
        <span
          data-testid="sig-preview"
          className="text-5xl text-neutral-900 sm:text-6xl"
          style={{ fontFamily: font.family }}
        >
          {trimmed || m.sig_preview_placeholder()}
        </span>
      </div>

      <div className="flex justify-end">
        <Button type="button" onClick={download} disabled={!trimmed}>
          {m.sig_download()}
        </Button>
      </div>
    </div>
  );
}
